<template>
  <div class="breadcrumb-container" v-if="breadcrumbs.length > 0">
    <div class="header-bg"></div>
    <div class="container">
      <template v-for="(item, index) in breadcrumbs">
        <span :key="index" v-if="item.name">
          <span v-if="index !== 0" class="separator"> > </span>
          <router-link v-if="item.path" :to="item.path">{{ item.name }}</router-link>
          <span v-else class="current">{{ item.name }}</span>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data() {
    return {
      breadcrumbs: []
    };
  },
  watch: {
    '$route'() {
      this.generateBreadcrumbs();
    }
  },
  created() {
    this.generateBreadcrumbs();
  },
  methods: {
    generateBreadcrumbs() {
      let matched = this.$route.matched.filter(item => item.meta && item.meta.breadcrumb);
      
      const breadcrumbs = matched.map(route => {
         const breadcrumb = route.meta.breadcrumb;
         let name = typeof breadcrumb === 'function' ? breadcrumb(this.$route) : breadcrumb.name;
         
         // Support for i18n
         if (this.$t) {
            name = this.$t(name);
         }
         
         // Handle dynamic segments
         if (this.$route.params.id && route.path.includes(':id')) {
            if (this.$route.meta.dynamicBreadcrumb) {
               name = this.$route.meta.dynamicBreadcrumb(this.$route) || name;
            } else {
                // Fallback for product name if not provided dynamically
                const lastSegment = this.$route.path.split('/').pop();
                name = this.$route.params.name || this.productName || name;
            }
         }

        return {
          name: name,
          path: route.path ? this.fillParams(route.path, this.$route.params) : null
        };
      });

      // If the last breadcrumb is the same as the product name from the route state,
      // we avoid duplicating it.
      if (this.$route.params.state) {
          try {
              const state = JSON.parse(decodeURIComponent(this.$route.params.state));
              if (state.productName && breadcrumbs.length > 0 && breadcrumbs[breadcrumbs.length - 1].name === state.productName) {
                  breadcrumbs.pop();
              }
          } catch(e) {
              console.error("Could not parse route state for breadcrumbs", e);
          }
      }

      this.breadcrumbs = breadcrumbs;
    },
    fillParams(path, params) {
        for (const key in params) {
            path = path.replace(`:${key}`, params[key]);
        }
        return path;
    }
  },
  props: {
      productName: {
          type: String,
          default: ''
      }
  }
};
</script>

<style lang="less" scoped>
.breadcrumb-container {
  padding: 20px 0;
  position: relative;
  text-align: left;
  color: #ffffff;
  font-size: 16px;
  
  .header-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.8;
    filter: brightness(0.8);
    z-index: 1;
  }
  
  .container {
    position: relative;
    z-index: 2;
    max-width: 1520px;
    margin: 0 auto;
    padding: 0;
  }

  .separator {
    margin: 0 8px;
    color: rgba(255, 255, 255, 0.7);
  }

  .current {
    color: #ffffff;

  }
  
  a {
    color: #ffffff;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style> 